// @mui material components
import Drawer from "@mui/material/Drawer";
import { styled, Theme } from "@mui/material/styles";
import { globalColors } from "assets/colors-global";
import colors from "assets/theme/base/colors";
import { PAGE_HEADER_HEIGHT_MOBILE } from "layouts/Main/styles";

export default styled(Drawer)(
  ({ theme, ownerState }: { theme?: Theme | any; ownerState: any }) => {
    const { palette, boxShadows, transitions, breakpoints, functions } = theme;
    const { transparentSidenav, whiteSidenav, miniSidenav } = ownerState;

    const sidebarWidth = 270;
    const { transparent, gradients, grey } = palette;
    const { xxl } = boxShadows;
    const { pxToRem, linearGradient } = functions;

    let backgroundValue = linearGradient(
      gradients.primary.state,
      gradients.primary.main,
      90
    );

    if (transparentSidenav) {
      backgroundValue = transparent.main;
    } else if (whiteSidenav) {
      backgroundValue = globalColors.sidebar.main;
    }

    // styles for the sidenav when miniSidenav={false}
    const drawerOpenStyles = () => ({
      background: backgroundValue,
      transform: "translateX(0)",
      transition: transitions.create("transform", {
        easing: transitions.easing.sharp,
        duration: transitions.duration.shorter,
      }),
      [breakpoints.down("lg")]: {
        top: pxToRem(PAGE_HEADER_HEIGHT_MOBILE),
        height: `calc(100% - ${pxToRem(PAGE_HEADER_HEIGHT_MOBILE)})`,
        margin: 0,
      },
      [breakpoints.up("xl")]: {
        boxShadow: transparentSidenav ? "none" : xxl,
        marginBottom: transparentSidenav ? 0 : "inherit",
        left: "0",
        width: sidebarWidth,
        transform: "translateX(0)",
        transition: transitions.create(["width", "background-color"], {
          easing: transitions.easing.sharp,
          duration: transitions.duration.enteringScreen,
        }),
      },
    });

    // styles for the sidenav when miniSidenav={true}
    const drawerCloseStyles = () => ({
      background: backgroundValue,
      transform: `translateX(${pxToRem(-320)})`,
      transition: transitions.create("transform", {
        easing: transitions.easing.sharp,
        duration: transitions.duration.shorter,
      }),

      [breakpoints.up("xl")]: {
        boxShadow: transparentSidenav ? "none" : xxl,
        marginBottom: transparentSidenav ? 0 : "inherit",
        left: "0",
        width: pxToRem(96),
        overflowX: "hidden",
        transform: "translateX(0)",
        transition: transitions.create(["width", "background-color"], {
          easing: transitions.easing.sharp,
          duration: transitions.duration.shorter,
        }),
      },
    });

    return {
      "& .MuiDrawer-paper": {
        boxShadow: xxl,
        border: `1px solid ${colors.grey[100]}`,

        ...(miniSidenav ? drawerCloseStyles() : drawerOpenStyles()),
      },
      ".MuiBox-root": {
        color: globalColors.primary3.main,
      },
      ".MuiListItemText-root span": {
        fontSize: "14px",
      },
    };
  }
);
